var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.regles),function(regle){return _c('ttbox-regle',{key:regle.idRegle,attrs:{"regle":regle},on:{"change":_vm.refresh}})}),_c('ttbox-regle',{attrs:{"nouvelleRegle":true},on:{"change":_vm.refresh}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }